const decimal2hex = (decimal) => {
  const hex = decimal.toString(16);
  return hex.length >= 2 ? hex : `0${hex}`;
};

export default decimal2hex;
